<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'contratacion', title: '3. Contratación - General' },
  { id: 'plan-adquisiciones', title: '3.1 Plan Anual de Adquisiciones' },
  { id: 'info-contractual', title: '3.2 Publicación de la información contractual' },
  { id: 'ejecucion-contratos', title: '3.3 Publicación de la ejecución de los contratos' },
  { id: 'manual-contratacion', title: '3.4 Manual de contratación' },
  { id: 'formatos-contratos', title: '3.5 Formatos o modelos de contratos' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="3. Contratación" />
</template>
